module.exports = __webpack_public_path__ + "assets/b4410086be0c9b0e04ed874b1525b954.mp3";